import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "teal"
}
const _hoisted_2 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = {
  href: '/coaches',
  class: "text-sm text-blue-700 hover:text-blue-900 mb-6 inline-block"
}
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-2xl font-bold text-gray-900 mb-2" }
const _hoisted_8 = { class: "flex flex-wrap gap-2 mb-4" }
const _hoisted_9 = {
  key: 0,
  class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
}
const _hoisted_10 = {
  key: 1,
  class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700"
}
const _hoisted_11 = {
  key: 2,
  class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-600 text-white"
}
const _hoisted_12 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_13 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 mr-2" }
const _hoisted_14 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_15 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800" }
const _hoisted_16 = {
  key: 3,
  class: "text-gray-600 mb-4 whitespace-pre-line"
}
const _hoisted_17 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 4,
  class: "mb-6"
}
const _hoisted_22 = {
  key: 0,
  class: "text-sm font-semibold text-gray-700 mb-2"
}
const _hoisted_23 = {
  key: 1,
  class: "flex flex-wrap gap-2 mb-3"
}
const _hoisted_24 = { class: "rounded-lg border border-gray-200 overflow-hidden map-container" }
const _hoisted_25 = {
  ref: "mapContainer",
  style: {"height":"300px","width":"100%"}
}
const _hoisted_26 = {
  key: 5,
  class: "flex gap-3 mt-4"
}
const _hoisted_27 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "coaches"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, "← " + _toDisplayString($setup.t('coaches.back_to_list')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        ($setup.coach.logo_url)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                src: $setup.coach.logo_url,
                class: "w-20 h-20 rounded-lg object-cover border border-gray-200"
              }, null, 8 /* PROPS */, _hoisted_6)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("h1", _hoisted_7, _toDisplayString($setup.coach.name), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_8, [
          ($setup.coach.city)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.coach.city), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.coach.club)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($setup.coach.club), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.coach.online)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.t('coaches.online')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        ($setup.coach.pending && $props.userAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString($setup.t('coaches.pending')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.approveItem,
                class: "px-4 py-1.5 text-sm font-medium text-green-700 bg-green-50 rounded-lg hover:bg-green-100 transition"
              }, _toDisplayString($setup.t('coaches.approve')), 1 /* TEXT */)
            ]))
          : ($setup.coach.pending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString($setup.t('coaches.pending')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
        ($setup.coachDescription)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($setup.coachDescription), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_17, [
          ($setup.coach.phone)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: 'tel:' + $setup.coach.phone,
                class: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition"
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  })
                ], -1 /* CACHED */)),
                _createTextVNode(" " + _toDisplayString($setup.coach.phone), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_18))
            : _createCommentVNode("v-if", true),
          ($setup.coach.facebook_link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: $setup.coach.facebook_link,
                target: "_blank",
                class: "hover:opacity-80 transition"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  class: "w-7 h-7",
                  viewBox: "0 0 24 24",
                  fill: "#1877F2"
                }, [
                  _createElementVNode("path", { d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" })
                ], -1 /* CACHED */)
              ]))], 8 /* PROPS */, _hoisted_19))
            : _createCommentVNode("v-if", true),
          ($setup.coach.instagram_link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: $setup.coach.instagram_link,
                target: "_blank",
                class: "hover:opacity-80 transition"
              }, [...(_cache[2] || (_cache[2] = [
                _createStaticVNode("<svg class=\"w-7 h-7\" viewBox=\"0 0 24 24\"><defs><linearGradient id=\"ig-show\" x1=\"0%\" y1=\"100%\" x2=\"100%\" y2=\"0%\"><stop offset=\"0%\" stop-color=\"#feda75\"></stop><stop offset=\"25%\" stop-color=\"#fa7e1e\"></stop><stop offset=\"50%\" stop-color=\"#d62976\"></stop><stop offset=\"75%\" stop-color=\"#962fbf\"></stop><stop offset=\"100%\" stop-color=\"#4f5bd5\"></stop></linearGradient></defs><path fill=\"url(#ig-show)\" d=\"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12s.014 3.668.072 4.948c.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24s3.668-.014 4.948-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948s-.014-3.667-.072-4.947c-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z\"></path></svg>", 1)
              ]))], 8 /* PROPS */, _hoisted_20))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" Locations "),
        ($setup.locationsWithCoords.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              ($setup.locationsWithCoords.length > 1)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_22, _toDisplayString($setup.t('coaches.locations')) + " (" + _toDisplayString($setup.locationsWithCoords.length) + ")", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.locationsWithCoords.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.locationsWithCoords, (loc) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: loc.id,
                        class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700"
                      }, _toDisplayString(loc.name || $setup.t('coaches.location')), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, null, 512 /* NEED_PATCH */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($props.userAdmin || $setup.coach.user_id === $props.userId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("a", {
                href: `/coaches?edit=${$setup.coach.id}`,
                class: "px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
              }, _toDisplayString($setup.t('coaches.edit')), 9 /* TEXT, PROPS */, _hoisted_27),
              _createElementVNode("button", {
                onClick: $setup.deleteItem,
                class: "px-4 py-2 text-sm font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
              }, _toDisplayString($setup.t('coaches.delete')), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}